import React from 'react';
import { Typography, Box, Link } from '@mui/material';

function CertificateOfQualificationInfo() {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Certificate of Qualification
      </Typography>
      <Typography variant="body1" paragraph>
        A certificate of qualification proves that a person is qualified to work in a specific skilled trade in Canada. It is issued by the body that governs trades in a province or territory.
      </Typography>
      <Typography variant="body1" paragraph>
        Having a certificate of qualification can award significant points under the Comprehensive Ranking System (CRS). For example, under the Federal Skilled Trades Program (FSTP), it can be a key requirement.
      </Typography>
      <Link href="https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/express-entry/eligibility/skilled-trades/certificate-qualification.html" target="_blank" rel="noopener">
        Learn more about Certificates of Qualification
      </Link>
    </Box>
  );
}

export default CertificateOfQualificationInfo;